import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
ReactDOM.render(
    <App />
    , document.getElementById('root'));
registerServiceWorker();
//var Logo1=fs.Readfile(Logo);




// WEBPACK FOOTER //
// ./src/index.js